import React, { useEffect, useState } from "react";
import GlobalStyles, { CommonClasses } from "../../global/GlobalStyles";
import Breadcrumbs from "../../components/others/BreadCrumbs";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import api from "../../global/api";
import BigLoader from "../../components/loaders/BigLoader";

const breadcrumbItems = [
  { name: "Dashboard", path: "/admin/dashboard" },
  { name: "Manage users", path: "/admin/dashboard/manage-users" },
];

const ManageUsers = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const getUsers = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/users`);
      setUsers(response.data);
      setFilteredUsers(response.data); // Initialize filtered users with all data
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  // Filter users based on search term
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter(
        (user) =>
          user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (user.role &&
            user.role.toLowerCase().includes(searchTerm.toLowerCase()))
      );
      setFilteredUsers(filtered);
    }
  }, [searchTerm, users]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className={GlobalStyles.dashbooardPageContainer}>
      <div className={GlobalStyles.dashbooardPageWrap}>
        <div className={GlobalStyles.seperator}>
          <Breadcrumbs items={breadcrumbItems} />
          <Link to={`/secured/signup`} className={GlobalStyles.button}>
            Create user
          </Link>
        </div>
        <div className={GlobalStyles.searchContainer}>
          <FaSearch className={GlobalStyles.searchIcon} />
          <input
            type="text"
            placeholder="Search by email, name, or role"
            className={GlobalStyles.searchInput}
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
        {loading ? (
          <div className="w-full flex justify-center py-40">
            <BigLoader />
          </div>
        ) : (
          <>
            <span className={GlobalStyles.textCount}>
              {filteredUsers.length}{" "}
              {filteredUsers.length === 1 ? "user" : "users"} found
            </span>
            <div className="w-full flex flex-col gap-1">
              {filteredUsers.length > 0 ? (
                filteredUsers
                  .slice()
                  .reverse()
                  .map((user) => (
                    <div
                      key={user.id}
                      className={`w-full bg-light dark:bg-dark px-3 py-2 ${CommonClasses.transition} ${CommonClasses.rounded} flex justify-between items-center`}
                    >
                      <div className="flex flex-col">
                        <span className={GlobalStyles.textSecondary}>
                          {user.email}
                        </span>
                      </div>
                      <Link
                        className={GlobalStyles.button}
                        to={`/admin/dashboard/manage-users/${user.id}`}
                      >
                        View
                      </Link>
                    </div>
                  ))
              ) : (
                <div className={GlobalStyles.textCount}>No users found.</div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ManageUsers;
